module.exports = __webpack_public_path__ + "static/media/441228299_1886619605138132_8316484799573641844_n.bd8e429d.jpg";